import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sta",
  "use": "icon-sta-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sta\"><defs><style type=\"text/css\"></style></defs><path d=\"M937.3 900.4H541.7V717.9c0-16.5-13.5-30-30-30H126V494h161.8l46.6 80.8c3.5 6 8.8 10.4 14.8 12.8l0.6 0.3c14.7 7.5 32.9 1.6 40.3-13.1l129.7-254.5 92.9 160.9c0.3 0.6 0.7 1.2 1.1 1.7C618.7 493 629.1 500 641 500h261v188H699c-16.5 0-30 13.5-30 30s13.5 30 30 30h203c33 0 60-27 60-59.9V124.6c0-33-27-59.9-60-59.9H126c-33 0-60 27-60 59.9V688c0 33 27 59.9 60 59.9h355.7v152.5h-389c-13.6 0-24.7 11.1-24.7 24.7V936c0 13.6 11.1 24.7 24.7 24.7h844.7c13.6 0 24.7-11.1 24.7-24.7v-10.9c-0.1-13.6-11.2-24.7-24.8-24.7zM902 124.6V440H658.4L544.5 242.8c-8.2-14.2-26.4-19.2-40.7-11.1-5.2 2.8-9.7 7.1-12.6 12.8L360.7 500.4l-29.3-50.7c-0.7-1.3-1.5-2.4-2.4-3.5-5.5-7.4-14.2-12.2-24.1-12.2H126V124.6h776z\" p-id=\"15036\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/sta.svg
// module id = +MY1
// module chunks = 52